"use strict";
var distill;
(function (distill) {
    var datasets;
    (function (datasets) {
        var views;
        (function (views) {
            var createWizard2_select;
            (function (createWizard2_select) {
                let DatasetCreationMethod;
                (function (DatasetCreationMethod) {
                    DatasetCreationMethod["None"] = "None";
                    DatasetCreationMethod["Manual"] = "Manual";
                    DatasetCreationMethod["FormScreen"] = "FormScreen";
                    DatasetCreationMethod["DataSource"] = "DataSource";
                    DatasetCreationMethod["FileUpload"] = "FileUpload";
                })(DatasetCreationMethod || (DatasetCreationMethod = {}));
                class InitArgs {
                    constructor() {
                        this.wizardToken = '';
                        this.creationMethod = DatasetCreationMethod.None;
                        this.cruxEntityId = null;
                        this.uploadedFileToken = null;
                        this.availableForms = [];
                        this.availableDataSources = [];
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    $(function () {
                        bindEvents();
                        updateToolbar();
                    });
                }
                createWizard2_select.init = init;
                function getParentButton(selector) {
                    return $(parent.document).find(selector);
                }
                function bindEvents() {
                    getParentButton('#wizardBackBtn').on('click', function (e) {
                        e.preventDefault();
                        window.location.href = _initArgs.urls.navigateToStep + '?step=1&token=' + _initArgs.wizardToken;
                    });
                    getParentButton('#wizardNextBtn').on('click', function () {
                        if (validateForm())
                            submitForm();
                    });
                    $('#formPicker').on('change', function () {
                        var _a;
                        const entityId = ((_a = $(this).val()) === null || _a === void 0 ? void 0 : _a.toString()) || '';
                        if (entityId) {
                            $('#CruxEntityId').val(entityId);
                            submitForm();
                        }
                    });
                    $('#dataSourcePicker').on('change', function () {
                        var _a;
                        const entityId = ((_a = $(this).val()) === null || _a === void 0 ? void 0 : _a.toString()) || '';
                        if (entityId) {
                            $('#CruxEntityId').val(entityId);
                            submitForm();
                        }
                    });
                    const $dropZone = $('#fileDropZone');
                    const $fileInput = $('#fileUploadInput');
                    if ($dropZone.length) {
                        $dropZone.on('dragover', function (e) {
                            e.preventDefault();
                            $(this).addClass('bg-light');
                        });
                        $dropZone.on('dragleave drop', function (e) {
                            e.preventDefault();
                            $(this).removeClass('bg-light');
                        });
                        $dropZone.on('drop', function (e) {
                            var _a, _b;
                            e.preventDefault();
                            const files = (_b = (_a = e.originalEvent) === null || _a === void 0 ? void 0 : _a.dataTransfer) === null || _b === void 0 ? void 0 : _b.files;
                            if (files && files.length > 0)
                                handleFileSelected(files[0]);
                        });
                        $fileInput.on('change', function () {
                            const files = this.files;
                            if (files && files.length > 0)
                                handleFileSelected(files[0]);
                        });
                    }
                }
                function updateToolbar() {
                    const $next = getParentButton('#wizardNextBtn');
                    const method = _initArgs.creationMethod;
                    if (method === DatasetCreationMethod.FileUpload && _initArgs.uploadedFileToken)
                        $next.removeClass('d-none');
                    else
                        $next.addClass('d-none');
                }
                function validateForm() {
                    const method = _initArgs.creationMethod;
                    if (method === DatasetCreationMethod.FileUpload && !_initArgs.uploadedFileToken) {
                        appn.toast.notify(appn.toast.Type.error, T('Please upload a file.'));
                        return false;
                    }
                    if ((method === DatasetCreationMethod.FormScreen || method === DatasetCreationMethod.DataSource) && !$('#CruxEntityId').val()) {
                        appn.toast.notify(appn.toast.Type.error, T('Please select an entity.'));
                        return false;
                    }
                    return true;
                }
                function handleFileSelected(file) {
                    const dotIndex = file.name.lastIndexOf('.');
                    if (dotIndex === -1) {
                        appn.toast.notify(appn.toast.Type.error, T('Only CSV and XLSX files are supported.'));
                        return;
                    }
                    const ext = file.name.substring(dotIndex + 1).toLowerCase();
                    if (ext !== 'csv' && ext !== 'xlsx') {
                        appn.toast.notify(appn.toast.Type.error, T('Only CSV and XLSX files are supported.'));
                        return;
                    }
                    if (file.size > 50 * 1024 * 1024) {
                        appn.toast.notify(appn.toast.Type.error, T('File too large. Maximum size is 50MB.'));
                        return;
                    }
                    submitForm();
                }
                function submitForm() {
                    $('form')[0].submit();
                }
            })(createWizard2_select = views.createWizard2_select || (views.createWizard2_select = {}));
        })(views = datasets.views || (datasets.views = {}));
    })(datasets = distill.datasets || (distill.datasets = {}));
})(distill || (distill = {}));
